"use strict";

import { Box, Text } from '@autoguru/overdrive';
import clsx from 'clsx';
import { memo } from 'react';
import * as styles from './VehicleLookupItemRenderer.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const VehicleLookupItemRenderer = /*#__PURE__*/memo(({
  className: _className = '',
  suggestion,
  highlighted
}) => {
  return /*#__PURE__*/_jsx(Box, {
    as: "button",
    "aria-label": suggestion.text,
    className: clsx(_className, styles.option),
    display: "flex",
    flexGrow: 1,
    width: "full",
    paddingX: "4",
    paddingY: "3",
    backgroundColour: highlighted ? 'gray200' : 'white',
    onMouseDown: e => e.preventDefault(),
    children: /*#__PURE__*/_jsx(Text, {
      as: "p",
      size: "4",
      colour: "dark",
      align: "left",
      className: clsx(styles.optionText),
      children: suggestion.text
    })
  });
});